import(/* webpackMode: "eager" */ "/app/apps/zyno-customer-ui/app/global-error.tsx");
